import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';

import styles from './SelectInput.module.scss';
import { SelectInputProps } from './SelectInput.props';

const SelectInput = ({
  name,
  options,
  disabled,
  selectFirstOption,
  defaultValue,
}: SelectInputProps) => {
  const { t } = useTranslation();
  const { control, watch } = useFormContext();
  const value = watch(name);

  const selectOptions = options.reduce<Array<{ [key: string]: any }>>((total, item) => {
    total.push({
      value: item.key,
      label: item.value,
      isDisabled: item.disabled,
    });

    return total;
  }, []);

  const getOptionByKey = (key: string) => {
    return selectOptions.find((item) => {
      return String(item.value) === String(key);
    });
  };

  const customStyles = {
    option: (base: any) => ({
      ...base,
      fontSize: '14px',
    }),
    menuPortal: (base: any) => ({
      ...base,
      zIndex: 1001,
    }),
    control: (base: any) => ({
      ...base,
      paddingLeft: 8,
      height: 48,
      minHeight: 48,
    }),
  };

  const initialValue =
    getOptionByKey(defaultValue) ?? (selectFirstOption ? selectOptions[0] : null);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ onChange }) => {
        return (
          <Select
            onChange={(newValue) => {
              onChange(newValue?.value);
            }}
            styles={customStyles}
            value={getOptionByKey(value)}
            menuPortalTarget={document.body}
            className={styles.SelectInput__Select}
            options={selectOptions}
            isDisabled={disabled}
            defaultValue={initialValue}
            placeholder={t('FORMS.SELECT.PLACEHOLDER')}
          />
        );
      }}
    />
  );
};

export default SelectInput;
